import { Injectable } from '@angular/core';
import { AuthorizationRequestService } from '../../authorization-request.service';
import { AuthorizationCodeExchangeService } from '../../authorization-code-exchange/authorization-code-exchange.service';
import { AuthModule } from '../../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class AuthorizationCodeGrantService {

  constructor(private authorizationRequestService: AuthorizationRequestService,
    private authorizationCodeExchangeService: AuthorizationCodeExchangeService) { }

  createAuthorizationRequestUrl() {
    return this.authorizationRequestService.createAuthorizationRequestUrl();
  }

  runAuthorizationCodeExchange(code) {
    return this.authorizationCodeExchangeService.run(code);
  }
}
